import { useApp, type Screen } from './lib/store.tsx';
import { Main, GiftWho, GiftOccasion } from './screens/start.tsx';
import { When, SizeScreen, Swipes, Flowers } from './screens/quiz.tsx';
import { Result, Catalog, Surprise } from './screens/result.tsx';
import { Checkout, Zones } from './screens/checkout.tsx';
import { Pay } from './screens/pay.tsx';
import { OrderScreen, Delivered } from './screens/order.tsx';
import { Recipient } from './screens/recipient.tsx';
import { Profile, Person, DatesAdd, Support, Docs } from './screens/profile.tsx';
import { Individual } from './screens/individual.tsx';
import { GiftHow, Portrait } from './screens/portrait.tsx';
import { ToastHost } from './ui/kit.tsx';
import { MyOrders } from './screens/site.tsx';

/** Куда открыть приложение: по ссылке подарка, из уведомления бота или с главной. */
export function initialScreen(startParam: string | null, search: string): Screen {
  const q = new URLSearchParams(search);
  const gift = q.get('gift') ?? (startParam?.startsWith('g_') ? startParam.slice(2) : null);
  if (gift) return { name: 'recipient', token: gift };
  const s = q.get('s') ?? startParam ?? '';
  const [kind, arg] = s.split(':');
  if (kind === 'order' && arg) return { name: 'order', orderId: arg };
  if (kind === 'delivered' && arg) return { name: 'delivered', orderId: arg };
  if (kind === 'payfail' && arg) return { name: 'pay', orderId: arg };
  if (kind === 'person' && arg) return { name: 'person', personId: Number(arg) };
  if (kind === 'support' && arg) return { name: 'support', orderId: arg };
  if (kind === 'promos') return { name: 'profile' };
  if (kind === 'individual') return { name: 'individual' };
  if (kind === 'myorders') return { name: 'myOrders' };
  return { name: 'main' };
}

export function App() {
  const { screen } = useApp();
  return (
    <>
      <Route screen={screen} />
      <ToastHost />
    </>
  );
}

function Route({ screen }: { screen: Screen }) {
  switch (screen.name) {
    case 'main':
      return <Main />;
    case 'giftWho':
      return <GiftWho />;
    case 'giftHow':
      return <GiftHow />;
    case 'portrait':
      return <Portrait />;
    case 'giftOccasion':
      return <GiftOccasion />;
    case 'when':
      return <When />;
    case 'size':
      return <SizeScreen />;
    case 'swipes':
      return <Swipes />;
    case 'flowers':
      return <Flowers />;
    case 'result':
      return <Result />;
    case 'catalog':
      return <Catalog />;
    case 'surprise':
      return <Surprise />;
    case 'checkout':
      return <Checkout />;
    case 'zones':
      return <Zones />;
    case 'pay':
      return (
        <>
          <OrderScreen orderId={screen.orderId} />
          <Pay orderId={screen.orderId} kind={screen.kind} />
        </>
      );
    case 'order':
      return <OrderScreen key={screen.orderId} orderId={screen.orderId} />;
    case 'delivered':
      return <Delivered orderId={screen.orderId} />;
    case 'recipient':
      return <Recipient token={screen.token} />;
    case 'profile':
      return <Profile />;
    case 'person':
      return <Person personId={screen.personId} addTaste={screen.addTaste} />;
    case 'dates':
      return <DatesAdd />;
    case 'support':
      return <Support orderId={screen.orderId} />;
    case 'docs':
      return <Docs />;
    case 'individual':
      return <Individual />;
    case 'myOrders':
      return <MyOrders />;
  }
}
